import React from 'react'
import { Field } from 'redux-form'
import { Grid, Row, Col, Panel, Button, Image } from 'react-bootstrap'
import Form from 'components/Form'
import InputField from 'components/InputField'

export const View = ({ ...props }) => {
	return <Grid fluid>
		<Row className="show-grid">
			<Col md={4} sm={6} xs={8} mdOffset={4} smOffset={3} xsOffset={2}>
				<Row className="show-grid">
					<Col md={8} xs={12} mdOffset={2}>
						<Image src="/img/logo.svg" responsive className="center-block mt"  />
						<Panel>
							<Panel.Body>
								<h3 className="text-center mt-0">Login</h3>
								<Form {...props}>
									<Field
										id='email'
										name='email'
										component={InputField}
										type="email"
										label="E-mail"
										placeholder="Enter email"
									/>
									<Field
										id='password'
										name='password'
										component={InputField}
										label="Password"
										type="password"
										placeholder="Enter your password"
									/>
									<Button type="submit" bsStyle="primary" className="center-block">Let's get in!</Button>
								</Form>
							</Panel.Body>
						</Panel>
					</Col>
				</Row>
			</Col>
		</Row>
	</Grid>
}

export default View


// WEBPACK FOOTER //
// ./src/routes/Login/components/View.js